import {memo} from 'react';
import {SchoolData} from '@/map/@types';
import {AROUND_DATA_OPTIONS} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {withComma} from '@/utils';
import {NearbyInfoMarker} from './Marker';

interface IProps extends naver.maps.MarkerOptions {
  item: SchoolData;
  type: AreaAnalyticsFilter;
}

export const SchoolMarker = memo(
  ({map, position, item, type}: IProps) => {
    const grade = item?.gradeStudentCount
      ? [...item.gradeStudentCount].splice(0, item.type === '초등학교' ? 7 : 4)
      : [];
    const name = [
      item.name,
      ...grade.map(
        (i, idx) =>
          `${idx === grade.length - 1 ? '특수' : `${idx + 1}학년`} ${withComma(
            i ?? 0
          )}명`
      ),
    ];

    return (
      <NearbyInfoMarker
        config={{
          map,
          position,
        }}
        item={{
          name,
          count: item.studentsCount,
        }}
        typeInfo={AROUND_DATA_OPTIONS[type]}
      />
    );
  },
  (prevProps: IProps, nextProps: IProps) => {
    return prevProps.position.toString() === nextProps.position.toString();
  }
);
